import { ErrorMessage as FieldMessage } from "formik";
import { FormikErrorMessage as MessageRenderer } from "./ErrorMessage";

interface FieldErrorProps {
    name: string;
}

export const FieldError = ({ name }: FieldErrorProps) => {
    return <FieldMessage name={name}>{(message) => <MessageRenderer message={message} />}</FieldMessage>;
};
